<script lang="ts" setup>
defineProps<{
  icon: string
  title: string
}>()
</script>

<template>
  <a
    class="flex items-center"
    href="#"
  >
    <SvgIcon class="!size-5" :name="icon" />

    <span class="ml-2 hidden text-sm leading-[1.71] text-main-silver md:block">
      {{ title }}
    </span>
  </a>
</template>
